import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";

export const getUserJobRole = () => {
  return base.get({
    url: API_PARAM.USER_JOB_ROLE,
  });
};

export const getUserSkills = () => {
  return base.get({
    url: API_PARAM.USER_SKILLS,
  });
};

export const getUserJobGoals = () => {
  return base.get({
    url: API_PARAM.USER_JOB_GOALS,
  });
};

export const getUserSkillGoals = () => {
  return base.get({
    url: API_PARAM.USER_SKILL_GOALS,
  });
};

export const getJobDetails = async (jobId) => {
  return base.get({
    url: API_PARAM.JOBS_DETAILS,
    params: { id: jobId },
  });
};

export const getSkillDetails = async (skillId) => {
  return base.get({
    url: API_PARAM.SKILL_DETAILS,
    params: { id: skillId },
  });
};

export const saveStep = (data) => {
  return base.post({
    url: API_PARAM.SAVE_STEP,
    data: data,
  });
};

export const addJobGoal = async (id) => {
  return base.post({
    url: API_PARAM.ADD_JOB_GOAL,
    params: { id },
  });
};

export const addSkillGoal = async (id) => {
  return base.post({
    url: API_PARAM.ADD_SKILL_GOAL,
    params: { id },
  });
};

export const removeJobGoal = async (id) => {
  return base.post({
    url: API_PARAM.REMOVE_JOB_GOAL,
    params: { id },
  });
};

export const removeSkillGoal = async (id) => {
  return base.post({
    url: API_PARAM.REMOVE_SKILL_GOAL,
    params: { id },
  });
};
